import NotFound from './notFound';
export default NotFound;
